export default {
  install (Vue, options) {
    const infobipSetUser = (useInfo) => {
      const account = useInfo?.Account?.split('_') || []
      if (account[0] === 'auth' && account[1]?.length === 10) {
        if (typeof pe !== 'undefined' && pe) {
          pe.setPerson({ phone: `+8869${account[1].substring(2)}` })
        }
      } else {
        if (typeof pe !== 'undefined' && pe) {
          pe.forgetPerson()
        }
      }
    }

    const infobipForgetUser = () => {
      if (typeof pe !== 'undefined' && pe) {
        pe.forgetPerson()
      }
    }

    const infobipTrackEvent = (name, attr) => {
      if (typeof pe !== 'undefined' && pe) {
        pe.track(name, attr)
      }
    }

    Vue.prototype.$infobipSetUser = infobipSetUser
    Vue.prototype.$infobipForgetUser = infobipForgetUser
    Vue.prototype.$infobipTrackEvent = infobipTrackEvent
  }
}
